module.exports = __webpack_public_path__ + "static/media/fond-nuages-960.1ae0bc52.png";